<template>
    <div>
        <div
            class="icon--helper"
            :class="{ active: showDialog }"
            @click="openHandler"
        >
            <div class="tooltip-wrapper">
                <div class="tooltip track-cms-content html-block" v-html="html"></div>
            </div>
        </div>
        <div v-if="showDialog" class="mobile-wrapper">
            <div class="track-cms-content mobile-content">
                <div class="close-button" @click="showDialog = false"/>
                <div class="tooltip track-cms-content html-block" v-html="html"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const getters = ['width'];

export default {
    name: 'HeaderTooltip',

    props: {
        html: {
            type: String,
        },
    },

    data() {
        return {
            showDialog: false,
            xsWidth: 375,
        };
    },

    computed: {
        ...mapGetters(getters),
    },

    methods: {
        openHandler() {
            if (this.width <= this.xsWidth) {
                this.showDialog = true;
            }
        },
    },
};
</script>

<style lang="scss">
    .tooltip.track-cms-content {
        p,
        li {
            /*font-family: Proxima Nova;*/
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 24px;
            color: #2A2626;
            margin-top: 16px;
            margin-bottom: 16px;
        }

        ul {
            margin: 0;
            padding-left: 18px;

            li {
                margin-bottom: 16px;
                &:first-child {
                    margin-top: 0;
                }
                &:last-child {
                     margin-bottom: 0;
                }
            }
        }
    }
</style>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .icon--helper {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-left: 8px;
        width: 24px;
        height: 24px;
        background-image: url("~@/assets/images/account-track/icon/help-circle-outline.svg");
        background-size: contain;
        cursor: pointer;
        z-index: 21;

        &.active, &:hover {
            background-image: url("~@/assets/images/account-track/icon/help-circle.svg");
        }

        &:hover .tooltip {
            display: block;

            @include on-xs {
                display: none;
            }

        }

        .tooltip {
            cursor: default;
            display: none;
            position: absolute;
            top: 11px;
            left: -36px;
            z-index: 21;
            background: #FFFFFF;
            box-shadow: 0 2px 12px rgba(107, 116, 123, 0.25);
            border-radius: 4px;
            width: 482px;
            padding: 16px 24px 24px;

            @include on-sm {
                left: -178px;
                width: 80vw;
            }

            &::after {
                content: " ";
                position: absolute;
                bottom: 100%;  /* At the top of the tooltip */
                left: 37px;
                margin-left: -12px;
                border-width: 12px;
                border-style: solid;
                border-color: transparent transparent white transparent;
                cursor: pointer;

                @include on-sm {
                    left: 178px;
                }
            }
        }

        .tooltip-wrapper {
            width: 1px;
            height: 1px;
            position: relative;
        }
    }

    .mobile-wrapper {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 99999;
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
        padding: 16px;
        background: rgba(#2A2626, 0.5);
    }

    .mobile-content {
        position: relative;
        overflow-y: auto;
        padding: 40px 16px;
        border-radius: 4px;
        background: #FFFFFF;
        box-shadow: 0 6px 24px rgba(155, 161, 166, 0.4);
        width: 100%;
        max-height: 100%;
    }

    .close-button {
        position: absolute;
        top: 16px;
        right: 16px;
        z-index: 1;
        width: 12px;
        height: 12px;
        background: url("~@/assets/images/icons/close-grey.svg") no-repeat center/contain;
        cursor: pointer;
    }
</style>
